const MEDIA_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? (process.env.REACT_APP_MEDIA_URL || 'http://localhost:5001')
    : '';

export const resolveMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return url;

  const trimmed = url.trim();
  if (!trimmed) return trimmed;

  if (/^https?:\/\//.test(trimmed) || trimmed.startsWith('data:')) {
    return trimmed;
  }

  const path = trimmed.startsWith('/uploads/')
    ? trimmed.replace('/uploads/', '/api/uploads/')
    : trimmed;

  if (path.startsWith('/')) {
    return `${MEDIA_BASE_URL}${path}`;
  }

  return path;
};
